import React, { useState, useEffect } from "react";
import { Text, FlatList, StyleSheet, TouchableOpacity, Image, ActivityIndicator } from "react-native";
import { View, Dimensions } from "react-native";
const Blogs = props => {
    const [datablog, setBlogData] = useState([]);
    React.useEffect(() => {
        fetch('https://app.arshehkar.com/query/public/GetListBlog.php')
            .then(response => response.json())
            .then(async (datablog) => {
                setBlogData(datablog);
            });
    }, []);
    return (
        <View style={styles.container}>
                  <Image source={require('../assets/images/products/banner.jpg')} style={styles.banner} />

            {
                !datablog ?
                    <ActivityIndicator size="large" color='blue' />
                    :
                    <FlatList
                        data={datablog}
                        style={{ margin: 4 }}
                        renderItem={({ item }) =>
                            <View style={styles.listRow} key={item.id}>

                                <TouchableOpacity style={{
                                    flex: 1,
                                    flexDirection: 'row',justifyContent:'flex-end'
                                }} onPress={() => props.navigation.navigate('BlogDetail', { blog: item })}>

                                    <Text style={styles.title}>{item.title}</Text>
<Image style={styles.img} source={item.image} />
                                </TouchableOpacity>
                            </View>
                        }
                    />

            }

        </View>
    )
}
const styles = StyleSheet.create(
    {
        banner:
        {
            width: '100%',
            height: 70,
            borderRadius: 6,
            marginBottom: 10, resizeMode: 'streach',
            shadowColor: '#000',
            shadowOffset: { height: 0 },
            shadowOpacity: 0.3,
            shadowRadius: 4,
        },
        listRow: {
            height: 76,
            padding: 5,
            margin: 2,
            backgroundColor: '#fff',
            color: '#fff',
            borderRadius: 4,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,
        }
        ,
        title: {
            paddingRight: 15,
            padding: 17,
            fontFamily: 'IranSans',
            fontSize: 14,
        }
        ,
        img: {
            width: 76,
            height: "100%",
            borderRadius: 3,
            resizeMode: 'contain',
        },
        
    container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        margin: 10,
        marginBottom: 0,
    }
    }
)
export default Blogs;